import axios from "src/utils/axios";

class MgmtSociety {

  societyList = () =>
    new Promise((resolve, reject) => {

      axios
        .get("/api/master/society/list")
        .then((response) => {

          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject(response.data.error);
          }

        })
        .catch((error) => {
          reject(error);
        });

    });

  addSociety = (societyInfo) =>
    new Promise((resolve, reject) => {

      const payload = {
        societyName: societyInfo.societyName,
        city: societyInfo.city,
        area: societyInfo.area,
        state: societyInfo.state,
        pinCode: societyInfo.pinCode
      };

      axios
        .post("/api/master/add/society", payload)
        .then((response) => {

          if (response?.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }

        })
        .catch((error) => {
          reject(error);
        });

    });

  editSociety = (societyInfo) =>
    new Promise((resolve, reject) => {

      const payload = {
        societyId: societyInfo.societyId,
        societyName: societyInfo.societyName,
        city: societyInfo.city,
        state: societyInfo.state,
        pinCode: societyInfo.pinCode
      };

      axios
        .post("/api/master/add/society", payload)
        .then((response) => {

          if (response?.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }

        })
        .catch((error) => {
          reject(error);
        });

    });

    deleteSociety = (societyId) =>
  new Promise((resolve, reject) => {

    axios
      .delete("/api/master/delete/society", {
        data: {
          societyId: societyId,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });

  });

}

const mgmtSociety = new MgmtSociety();

export default mgmtSociety;